'use strict';

import angular from 'angular';

import translate from '../translate';

import activities from './activities';
import activityIcons from './activity_icons';
import countries from './countries';
import keyCodes from './key_codes';
import languages from './languages';
import meetingTimeOptions from './meeting_time_options';
import messengerModalTypes from './messenger_modal_types';
import numberOfPeople from './number_of_people';
import patterns from './patterns';
import paymentTypes from './payment_types';
import photoSizes from './photo_sizes';
import socialNetworks from './social_networks';
import videos from './videos';
import currencies from './currencies';
import seoActivities from './seo_activities';

export default angular
  .module('constants', [translate])
  .constant('activities', activities)
  .constant('activityIcons', activityIcons)
  .constant('countries', countries)
  .constant('keyCodes', keyCodes)
  .constant('languages', languages)
  .constant('meetingTimeOptions', meetingTimeOptions)
  .constant('messengerModalTypes', messengerModalTypes)
  .constant('numberOfPeople', numberOfPeople)
  .constant('patterns', patterns)
  .constant('paymentTypes', paymentTypes)
  .constant('photoSizes', photoSizes)
  .constant('socialNetworks', socialNetworks)
  .constant('videos', videos)
  .constant('currencies', currencies)
  .constant('seoActivities', seoActivities)
  .name;



// WEBPACK FOOTER //
// ./app/src/constants/index.js